import React from 'react'; //eslint-disable-line
import Cookies from 'js-cookie';
import {connect} from '../../redux/helpers/helpers';
import {logIn} from '../../redux/reducers/session/session-reducer';
import Header from '../header/header';
import {BrowserRouter, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import './app-wrapper.scss';
import hasPermission from '../../has-permission';

class SessionManager extends React.Component {
  constructor(props) {
    super(props);

    //TODO logout doesn't do anything - I think this note is no longer relevant (max)
    this.token = Cookies.get('api-token') || Cookies.get('x-domain-api-token');

    if (this.token) this.props.logIn({token: this.token});
  }

  render() {
    var {session, authGroup} = this.props;
    var isLoading = this.token !== undefined && session.isLoading !== false && !session.isLoggedIn;
    var isRedirecting = false;

    if (!isLoading && authGroup) { //the whole app requires a minimum auth group
      isRedirecting = !hasPermission({requiredAuthGroup: authGroup, user: session.user});

      if (isRedirecting) {
        var domain = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://henrybuilt.com';

        window.location.replace(`${domain}/login?redirect_url=${window.location.href}`);
      }
    }

    return isLoading || isRedirecting ? null : this.props.children;
  }
}

SessionManager = connect({mapDispatch: {logIn}})(SessionManager);

class AppWrapper extends React.Component {
  render() {
    var {appKey} = this.props;

    return (
      <Provider store={this.props.store}>
        <BrowserRouter>
          <SessionManager authGroup={this.props.authGroup}>
            <div className='hb-app-wrapper'>
              {!this.props.hideHeader && (<Route render={(props) => <Header {...props} {...{appKey}}/>}/>)}
              <div className='hb-content'>
                {this.props.children}
              </div>
            </div>
          </SessionManager>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default AppWrapper;
